import { Link, useNavigate } from "react-router-dom";
import { Card } from "../Components/Card";
import { BellIcon } from "@heroicons/react/20/solid";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Colors } from "../constants/Colors";
// prettier-ignore
const detailMetadata = {
  "Internet Online": {
    color: Colors.alertsgreen100,
  },
  "Internet Dying Gasp": {
    color: Colors.alertsgreen100,
  },
  "Internet Offline": {
    color: Colors.alertsred100,
  },
  "Internet LOS": {
    color: Colors.alertsred100,
  },
  "Internet Tech Issue": {
    color: "#a7a9ac",
  },
  "Internet Unknown": {
    color: "#a7a9ac",
  },
  "Internet Suspend": {
    color: Colors.alertsyellow100,
  },
  "attention": {
    color: Colors.alertsyellow100,
  },
  "down": {
    color: Colors.alertsred100,
  },
};

// prettier-ignore
const alarmLinks = {
  "Read": "read",
  "Unread": "unread"
}

export const DeviceDetailCard = ({ headerText, loginType, data }) => {
  const containerRef = useRef(null);
  const itemRef = useRef(null);
  const [maxItems, setMaxItems] = useState(0); // maximum number of CardSubItems that can fit without overflowing
  const { t } = useTranslation();

  useEffect(() => {
    if (containerRef.current && itemRef.current) {
      // calculate maximum number of CardSubItems that can fit without overflowing
      const containerHeight = containerRef.current.offsetHeight;
      const itemHeight = itemRef.current.offsetHeight;

      if (itemHeight > 0) {
        const m = Math.floor(containerHeight / itemHeight);
        setMaxItems(m);
      }
    }
  }, [data]);

  return (
    <Card
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "0.5rem",
        fontSize: "1rem",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          flexGrow: "1",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CardHeader headerText={headerText} link={alarmLinks[headerText]} count={data.length} />
        { data.length > 0 ? (
        <div
          style={{
            // flexGrow: "1",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            // justifyContent: "center",
            overflowX: "hidden",
            overflowY: "auto",
            width: "100%",
            
          }}
          ref={containerRef}
        >
          {/* Render first item to measure item height */}
          <div
            ref={itemRef}
            style={{ visibility: "hidden", position: "absolute" }}
          >
            {data.length > 0 && <CardSubItem subItem={data[0]} />}

          </div>

          {/* Render up to maxItems without overflowing */}
          {data.slice(0, maxItems).map((el, index) => (
            <CardSubItem subItem={el} key={index} />
          ))}
        </div>
        ) : (
          
          <div style={{ padding: "1rem", textAlign: "center", fontSize: "0.8rem" }}>{t("general.noData")}</div>
        )}

      </div>
    </Card>
  );
};

const CardHeader = ({ headerText, link, count }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: Colors.neutral10,
        justifyContent: "space-between",
        padding: "3px 10px",
        borderRadius: "5px",
        fontWeight: "bold",
        fontSize: "0.8rem",
      }}
    >
      <div style={{ display: "flex", gap: "0.5rem" }}>
        <BellIcon width={"1rem"} />
        {headerText}
      </div>
      {count > 0 && (
      <Link to={link} style={{ color: Colors.primary100, fontWeight: "normal" }}>
        {t("prime.deviceList.viewAll")}
      </Link>
      )}
    </div>
  );
};

const CardSubItem = ({
  subItem: { name, identifier, lastUpdated, description, alarmType, id },
}) => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        gap: "0.5rem",
        width: "100%",
        margin: "8px",
        marginBottom: "0",
        cursor: "pointer",
        borderLeft: `5px solid ${
          detailMetadata[alarmType]?.color ?? "#ffb220"
        }`,
        paddingLeft: "0.4rem",
      }}
      onClick={() => navigate(`/alarms/${id}`)}
    >
      <div
        style={{
          flexGrow: "1",
          fontSize: "0.8rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "95%",
            fontWeight: "bold",
          }}
        >
          <div>{name}</div>
          <div
          style={{
            fontWeight: 500,
            fontSize: "0.7rem",
          }}
          >{lastUpdated}</div>
        </div>
        <div style={{ color: "#525252" }}>{identifier}</div>
        <div>
          {description.map((el, idx) => (
            <div key={`${identifier}-${idx}`}>
              {el}
              <br />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
